import MyHttp from '../utils/tools/request/request.js'
import giftCardApi from './giftcard/'
import wechatApi from './wechat/'
import memberApi from './member/'
import integralApi from './integral/'
import publicApi from './public/'
import couponApi from './coupon/'
import spareMoneyApi from './spareMoney/'
import depositApi from './deposit/'
import integralMallApi from './integral/mall'
const ALL_API = Object.assign({}, giftCardApi, wechatApi, memberApi, publicApi, couponApi, integralApi, spareMoneyApi, integralMallApi, depositApi)
const Api = new MyHttp({}, ALL_API)
export default Api



// WEBPACK FOOTER //
// ./src/api/index.js